import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
import { Environment } from '@as-react/common-utils';
class SizeGuideAPI {
    fetchSizeGuide(baseUrl, defaultRequestParams, sizeGuideRequestParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${baseUrl}api/aem/product/sizeguide`,
                params: Object.assign(Object.assign({}, defaultRequestParams), sizeGuideRequestParams),
            };
            const sizeGuideEndpointRequest = yield axiosClient.request(axiosConfig);
            return sizeGuideEndpointRequest.data;
        });
    }
    fetchSizeGuideHTML(sizeGuideUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            let sizeGuideHTMLEndpoint = `${sizeGuideUrl}.partial.html`;
            if (Environment.isDevelopment()) {
                sizeGuideHTMLEndpoint = `/content/platform-blueprints/asadventure${sizeGuideHTMLEndpoint}`;
            }
            const sizeGuideHTMLRequest = yield axiosClient.get(sizeGuideHTMLEndpoint);
            return sizeGuideHTMLRequest.data;
        });
    }
}
export default new SizeGuideAPI();
